/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector } from "react-redux";
import {Button} from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import {
    sortBy,
} from 'lodash';

import ManagedMatchTypesTable from "./ManagedMatchTypesTable";
import FormTextInput from "../../common/components/FormTextInput";

import {
    clearSelected,
    setSearchCriteria,
    getManagedMatchTypesCount,
    getManagedMatchTypes
} from "./managedMatchTypesSlice";

import BreadCrumb from "../../common/components/BreadCrumb";
import DropdownAction from "../../common/components/DropdownAction";
import PanelHeader from "../../common/components/layout/PanelHeader";
import SpinnerOverlay from "../../common/components/SpinnerOverlay";

import PanelTable from "../../common/components/layout/PanelTable";
import Container from "../../common/components/layout/Container";

const ManagedMatchTypes = (props) => {
    return (
        <ManagedMatchTypesComponent
        />
    );
};

const ManagedMatchTypesComponent = (props) => {
    const breadcrumbItems = [{label: 'Home', href: '/admin/home', isActive: false}, {
        label: 'Match Types',
        href: '',
        isActive: true
    }];
    const managedMatchTypesState = useSelector(state => state.managedMatchTypes);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [lastReload, setLastReload] = useState(Date.now());
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    useEffect(() => {
        // When open dialog, we clear state.
        dispatch(clearSelected());
    }, [lastReload, dispatch]);

    useEffect(() => {
        // When open dialog, we clear state.
        if (managedMatchTypesState.alertMessage) {
            setAlertMessage(managedMatchTypesState.alertMessage);
            setShowAlert(true);
        } else {
            setShowAlert(false);
        }
    }, [managedMatchTypesState.alertMessage]);

    const isReload = managedMatchTypesState.reload === true;

    useEffect(() => {
        dispatch(getManagedMatchTypesCount());
        dispatch(getManagedMatchTypes());
    }, [isReload, dispatch]);

    const handleOnKeyDown = (target) => {
        if (target.code === 'Enter') {
            setLastReload(Date.now())
        }
    }

    const handleRefresh = (target) => {
        setLastReload(Date.now());
    };

    const getActionItems = () => {
        const actionItems = [];

        actionItems.push(
            {
                label: 'EDIT',
                disabled: true,
                href: '',
                onClickHandler: () => navigate(`/admin/match-types/${managedMatchTypesState.selectedId[0]}/edit`),
                isActive: managedMatchTypesState.selectedMatchTypes && managedMatchTypesState.selectedMatchTypes.length === 1
            }
        );

        return sortBy(actionItems, 'label');
    };

    return (
        <Container>
            <BreadCrumb items={breadcrumbItems}></BreadCrumb>
            <PanelHeader
                header={`Match Types (${managedMatchTypesState.totalRecords.toLocaleString()})`}
                toolAction={
                    <div>
                        <Button
                            className="btn-min-width-120 btn-height-35"
                            variant="outline-secondary"
                            onClick={handleRefresh}
                        >REFRESH
                        </Button>
                        <DropdownAction items={getActionItems()} />
                        <Button
                            className="btn-min-width-120 btn-height-35"
                            variant="info"
                            disabled
                            onClick={() => navigate('/admin/match-types/create')}
                        >
                            CREATE
                        </Button>
                    </div>
                }
                searchBar={
                    <FormTextInput
                        placeholder={'Search by id, key, description'}
                        value={managedMatchTypesState.searchCriteria}
                        onKeyDown={handleOnKeyDown}
                        onChange={(value) => {
                            dispatch(setSearchCriteria(value));
                        }}
                        clearable
                        clearableHandle={() => {
                            dispatch(setSearchCriteria(''));
                            setLastReload(Date.now());
                        }}
                    >
                    </FormTextInput>
                }
            />
            <PanelTable>
                {managedMatchTypesState.loading && (
                    <SpinnerOverlay />
                )}
                <Alert
                    variant={"danger"}
                    show={showAlert}
                    onClose={() => setShowAlert(!showAlert)}
                    dismissible
                    transition={false}
                >
                    {alertMessage}
                </Alert>
                <ManagedMatchTypesTable lastReload={lastReload}/>
            </PanelTable>
        </Container>
    );
};

export default ManagedMatchTypes;
